/**
 * Generic -/+ quantity stepper: wires up any [data-qty-decrease]/
 * [data-qty-increase] button pair to the [data-qty-input] within the
 * same [data-qty] group, clamped to a minimum of 1. Shared by the cart
 * page (sections/cart.liquid) and the product page (sections/product.liquid)
 * so the increment/decrement/clamp behavior only lives in one place.
 *
 * This only adjusts the input's value and dispatches a real 'change'
 * event - it doesn't know or care what happens next. On the cart page,
 * assets/cart-quantity.js listens for that same 'change' event to sync
 * the new quantity to Shopify live. On the product page, the plain
 * add-to-cart form just reads the input's value normally on submit, so
 * no extra listener is needed there at all.
 */
(function () {
  document.addEventListener('click', function (event) {
    var decreaseButton = event.target.closest('[data-qty-decrease]');
    var increaseButton = event.target.closest('[data-qty-increase]');
    if (!decreaseButton && !increaseButton) return;

    var group = (decreaseButton || increaseButton).closest('[data-qty]');
    var input = group && group.querySelector('[data-qty-input]');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    if (decreaseButton && current <= 1) return;

    input.value = decreaseButton ? current - 1 : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
